import React from 'react';

const SvgPrice = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.385 21.102L3.173 14.89a1 1 0 01-.011-1.402l9.422-9.746a1 1 0 01.719-.305h6.448a1 1 0 011 1v6.454a1 1 0 01-.298.713l-9.66 9.504a1 1 0 01-1.408-.006zM17.364 8.32a1.345 1.345 0 100-2.69 1.345 1.345 0 000 2.69z"
}));

export default SvgPrice;